export default __webpack_public_path__ + "static/media/diamond-clarity-5.202330cf.png";